module.exports = __webpack_public_path__ + "img/c54.146f8c11.png";